<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="listingPattern">
            <div class="fixHeight ringlive-datalistWrap">
                <div class="listBoxes" v-for="(reward, index) in AgencyLastweekData " :key="reward.id">
                    <div class="leftBxb">
                        <div class="s-no">{{ index + 1 }}</div>
                        <div class="listIconBox">
                            <div class="profPic">
                                <img :src='defaultUserImage' alt="User Image" />
                            </div>
                        </div>
                        <div class="name-lavel-box">
                            <div class="userName">{{ reward.user.name }}
                            </div>
                        </div>
                    </div>
                    <div class="rightBox">
                        <div class="rightBox-in">
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                                {{ reward.total_coin_earned }}
                            </div>
                            <div class="userRewardsBox" v-if="reward.reward_coin > 0"><span>Reward</span>{{
            reward.reward_coin }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="personalDetails" class="listBoxes myselfBox">
                <div class="leftBxb">
                    <div class="s-no">-</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='defaultUserImage' alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ personalDetails.user.name }}</div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in"><img :src='beansIcon' class="beansIcon" alt="beans icons" />{{
                        personalDetails.total_coin_earned }}</div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from 'axios'
import beansIcon from '../../assets/images/beansIcon.png'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'AgencyLastWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            AgencyLastweekData: [],
            personalDetails: null,
            beansIcon: beansIcon,
            defaultUserImage: defaultUserImage,
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchAgencyLastweekData'
    },
    mounted() {
        this.fetchAgencyLastweekData();
    },
    methods: {
        fetchAgencyLastweekData() {
            this.loading = true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-agency-weekly?type=last_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.AgencyLastweekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                })

                .catch(error => {
                    console.error("Error Featching Last Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    },
}
</script>